import ProgressStepper from './components/progressStepper';
import Logo from './images/logo.png';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router';
import Details from './pages/details';
import Confirmation from './pages/confirmation';
import Payment from './pages/payment';
import Api from './utils/api';
import 'react-tooltip/dist/react-tooltip.css';

function Pay() {
    const [activeStep, setActiveStep] = useState(1);
    const [status, setStatus] = useState('pay-error');
    const [details, setDetails] = useState({});
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const id = searchParams.get('id');
        if (id) {
            const lookupData = async () => {
                try {
                    const response = await Api.post('/lookup', { id });
                    if (!response.data.error) {
                        const { efa, account_holder, address, city, state, zip, amounts } = response.data;
                        setDetails({ efa, account_holder, address, city, state, zip, response: { amounts } });
                    }
                } catch (error) {
                    console.error('Error looking up details:', error);
                }
            };
            lookupData();
        }
    }, [searchParams]);

    const submitDetails = (data, response) => {
        if (response) {
            data.response = response;
        }
        console.log(data);
        setDetails(data);
        setActiveStep(2);
    };

    const cancel = () => {
        setActiveStep(1);
    };

    const submitPayment = (status) => {
        setStatus(status);
        setActiveStep(3);
    };

    return (
        <Main>
            <Header>
                <img src={Logo} alt="Logo" />
                LeasePoint Funding Group
            </Header>
            <ProgressStepper activeStep={activeStep} />
            {activeStep === 1 && (
                <Details onSubmit={submitDetails} details={details} />
            )}
            {activeStep === 2 && (
                <Payment
                    onSubmit={submitPayment}
                    details={details}
                    update={details.mode !== 'payment' || details.response.amounts.length === 0}
                    onCancel={cancel}
                />
            )}
            {activeStep === 3 && <Confirmation status={status} />}
        </Main>
    );
}

const Header = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    align-content: center;
    align-items: center;
    gap: 10px;
    color: #00838f;
    font-weight: bold;
    margin: 20px 0;
`;

const Main = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    gap: 20px;
    max-width: 500px;
    margin: 0 auto;
`;

const Buttons = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
`;

export default Pay;
